export var EXTRA_LARGE = "75rem";
export var LARGE = "62rem";
export var TABLET = "48rem";
export var MOBILE = "36rem";